import { TENANT_REGIONS } from "../constants/tenantRegions";

const STORAGE_URLS = {
  'dxb': process.env.REACT_APP_STORAGE_URL_DXB,
  'ksa': process.env.REACT_APP_STORAGE_URL_KSA,
};

export const getRegionalStorageURL = (tenantId) => {
  const region = TENANT_REGIONS[tenantId] || 'dxb';
  return STORAGE_URLS[region] || STORAGE_URLS['dxb'];
};